/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 鼠标悬浮个人中心下拉显示底部cms列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.Article>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater-personal/list`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
